import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M200 112v88.9a7.1 7.1 0 01-7.1 7.1H40a8 8 0 01-8-8V88a8 8 0 018-8h45.3a8.1 8.1 0 014.8 1.6l27.8 20.8a8.1 8.1 0 004.8 1.6H192a8 8 0 018 8z"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M200 112v88.9a7.1 7.1 0 01-7.1 7.1H40a8 8 0 01-8-8V88a8 8 0 018-8h45.3a8.1 8.1 0 014.8 1.6l27.8 20.8a8.1 8.1 0 004.8 1.6H192a8 8 0 018 8z"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M64 80V56a8 8 0 018-8h45.3a8.1 8.1 0 014.8 1.6l27.8 20.8a8.1 8.1 0 004.8 1.6H224a8 8 0 018 8v88.9a7.1 7.1 0 01-7.1 7.1H200"
      />
    </svg>
  );
}

export default Icon;
